/**
 * Account-deletion sentinels shared by API and clients.
 *
 * When an account is deleted, the author's comment bodies are replaced with
 * this sentinel (their words are their personal data). Clients detect the
 * sentinel and render a localized "[deleted]" placeholder instead of the
 * literal value.
 */
export const DELETED_COMMENT_SENTINEL = '[deleted]';

/**
 * Name the API emits for a tombstoned user wherever user identity is
 * enriched onto other entities (members, payers, settlements, comments…).
 * Clients detect it and render a localized "Deleted user" with the
 * placeholder avatar. Resolved centrally in UserRepository.toDomainModel.
 */
export const DELETED_USER_SENTINEL = '[deleted user]';
